<template>
 <el-dialog
    title="修改个人信息"
    :modal-append-to-body='false'
    :visible.sync="updatePersonalInfodialogVisible"
    width="96%"
    class="update-info-wrap"
    :before-close="clslogm"
    :destroy-on-close="true"
    >
    <AddOrEditFormView class="user-form-wrap" ref="AddOrEditFormView" :contentConfig="contentConfig" :showFunBtn="false"    @cascaderChange="cascaderChange"  @selectChange="selectChange" @inputChange="inputChange">
      <!-- 附件 -->
      <template v-slot:fileUpload="data">
        <div class="item-wrap-title">
          <anybao-uploader ref="uploader" :file-status-text="fileConfig.fileStatusText" :PathId="fileConfig.PathId" :baseAddress="fileConfig.baseAddress" :currentUser="fileConfig.currentUser" :savePath="fileConfig.savePath" @file-removed="data.slotData.fileRemoved" @file-success="data.slotData.fileSuccess">
            <div>
              {{ data.slotData.title }}
              <anybao-uploader-btn>
                    上传附件
              </anybao-uploader-btn>
            </div>
            <anybao-uploader-unsupport></anybao-uploader-unsupport>
            <anybao-uploader-list></anybao-uploader-list>
          </anybao-uploader>
        </div>
      </template>
      <!-- 头像 -->
      <template v-slot:userPicture>
        <div class="item-wrap-pic">
          <anybao-uploader ref="picUploader" :baseAddress="baseAddress" :currentUser="currentUser" :single="true" :savePath="savePath" :PathId="PathId" :file-status-text="fileStatusText" @file-success="fileSuccess">
            <anybao-uploader-unsupport></anybao-uploader-unsupport>
            <!-- <anybao-uploader-drop> -->
            <anybao-uploader-btn>
              <div class="user-picture-wrap">
                <img :src="src" alt="">
              </div>
            </anybao-uploader-btn>
            <!-- </anybao-uploader-drop> -->
            <!-- <anybao-uploader-list></anybao-uploader-list> -->
          </anybao-uploader>
        </div>
      </template>
      <template v-slot:cursomContactInfo>
        <el-form ref="contactForm" :rules="ContactRules" :model="ContactInfoForm" label-position="left" class="item-form" :inline="false" label-width="180px" size="small">
          <el-row :gutter="120" class="contact-el-row" v-for="(item, index) in ContactInfoItem" :key="index">
            <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="18">
              <el-form-item v-for="(columns, i) in item.count" :key="i" class="contact-info-item" :prop="item.prop + '_' + i" :class="{'contact-info-item-validate': i === 0}">
                <template slot="label">
                  <div class="contact-info-item-label-wrap">
                    <i :class="[item.icon, 'contact-info-item-icon']"></i>
                    <el-select v-if="item.selectLabel" v-model="ContactInfoForm[item.selectProp + '_' + i]" class="contact-info-item-select-wrap">
                      <el-option v-for="v in item.selectOptions" :key="v.value" :label="v.lable" :value="v.value" />
                    </el-select>
                    <span v-else style="padding-left: 15px;">{{item.label}}</span>
                  </div>
                </template>
                <el-input v-model="ContactInfoForm[item.prop + '_' + i]" :disabled="item.disabled ? item.disabled : false"></el-input>
                <span class="contact-info-item-btns">
                  <el-button icon="el-icon-plus" circle size="mini" :disabled="item.prop === 'ContactDateInfoList'" type="primary" @click="AddSameContactProp(item)"></el-button>
                  <!-- 每种类型可添加多个，多个可删除，每种仅剩1条不可删除 -->
                  <el-button icon="el-icon-close" circle size="mini" type="primary" @click="DeleteSameContactProp(item, i)" :disabled="item.count === 1 && i === 0"></el-button>
                </span>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </template>
    </AddOrEditFormView>
    <span slot="footer" class="dialog-footer">
        <el-button @click="clslogm">取 消</el-button>
        <el-button class="margin-l-10" type="primary" @click="handleSubmit">确 定</el-button>
    </span>
    </el-dialog>

    
</template>
<script>
import { mapState } from "vuex";
 
import AddOrEditFormView from "@/components/AddOrEditFormView" 
import { getUserJobList, getSortRange, upDateUserInfo, GetCurrentEmergencyUserInfoById } from "@/api/modules/resources/userRun"
import { GetDictInfoListByType } from '@/api/modules/resources/administrationOrgan.js'
import { vxRule } from '@/utils/el-validate'
import { deepClone } from "@/util/userUtil"
import { getToken } from '@/util/auth'

import LazyCascader from "@/components/lazycascader/LazyCascader.vue"
export default {
  components: { AddOrEditFormView, LazyCascader },
  data() {
    const _this = this
    return{
      userInfoDetails: null,
      contentConfig: [
        {
          name: 'userPicture'
        },
        {
          title: '基础信息',
          form: {},
          labelWidth: '130px',
          rules: {
            SysUserCode: vxRule(true, 'Encode5', "blur", "只能输入1~9个数字、字母"),
            SysUserName: vxRule(true, null, "blur", "姓名不能为空"),
            IdNumber: vxRule(true, 'idNumber', "blur", "身份证信息不能为空"),
            SysUserSex: vxRule(true, null, "change", "性别不能为空"),
            SysUserState: vxRule(true, null, "change", "人员状态不能为空"),
            IsLock: vxRule(true, null, "change", "是否锁定不能为空"),
            IsLogin: vxRule(true, null, "change", "登录状态不能为空"),
          },
          formItemList: [
            {
              xl: 8,   
              lg: 8,
              md: 12,
              prop: 'SysUserCode',
              type: 'input',
              label: '工号',
              placeholder: '请输入工号',
              disabled: true
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'input',
              prop: 'SysUserName',
              label: '姓名',
              placeholder: '请输入姓名',
              disabled: true
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'input',
              prop: 'IdNumber',
              label: '身份证号',
              placeholder: '请输入身份证号',
              disabled: true
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '性别',
              prop: 'SysUserSex',
              type: 'radio',
              disabled: true,
              methods: () => {},
              list: [
                {
                  label: '男',
                  value: 1
                },
                {
                  label: '女',
                  value: 2
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '人员状态',
              type: 'radio',
              prop: 'SysUserState',
              disabled: true,
              methods: () => {},
              list: [
                {
                  label: '启用',
                  value: 1
                },
                {
                  label: '禁用',
                  value: 0
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '是否锁定',
              prop: 'IsLock',
              type: 'radio',
              disabled: true,
              methods: () => {},
              list: [
                {
                  label: '未锁定',
                  value: 0
                },
                {
                  label: '锁定',
                  value: 1
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '登录状态',
              prop: 'IsLogin',
              type: 'radio',
              disabled: true,
              methods: () => {},
              list: [
                {
                  label: '可登录',
                  value: 1
                },
                {
                  label: '不可登录',
                  value: 0
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              prop: 'Grade',
              label: '人员级别',
              type: 'rate',
              disabled: true
            },
          ]
        },
        {
          title: '职业信息',
          form: {},
          labelWidth: '130px',
          rules: {
            EmergencyCompanyofDeptList: vxRule(true, null, "change", "所属组织不能为空"),
            EmergencyPostInfoList: vxRule(true, null, "change", "所属岗位不能为空"),
            DutyId: vxRule(true, null, "change", "所属职务不能为空"),
          },
          formItemList: [
            {
              multiple: true,
              type: 'organization',
              prop: 'EmergencyCompanyofDeptList',
              isSelCompany: false, // 机构不可选 只能选组织
              label: '所属组织(可多选)',
              placeholder: '请输入所属组织',
              getValue: (val) => {
                this.EmergencyCompanyofDeptList = []
                val.length && val.forEach(v => {
                  this.EmergencyCompanyofDeptList.push({
                    CompanyId: v.CompanyId,
                    CompanyName: v.CompanyName,
                    DeptName: v.DeptName,
                    DeptId: v.DeptId,

                  })
                })
              }
            },
            {
              multiple: true,
              type: 'post',
              prop: 'EmergencyPostInfoList',
              label: '所属岗位(可多选)',
              placeholder: '请输入所属岗位',
              getValue: (val) => {
                this.EmergencyPostInfoList = []
                val.length && val.forEach(v => {
                  this.EmergencyPostInfoList.push({
                   PostId: v.ID,
                   PostName: v.Name
                  })
                })
              }
            },
            {
              multiple: true,
              type: 'select',
              prop: 'DutyId',
              list: [],
              label: '所属职务(可多选)',
              placeholder: '请输入职务'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'input',
              prop: 'Position',
              label: '职位',
              placeholder: '请输入职位'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'date',
              prop: 'EntryTime',
              label: '入职日期',
              placeholder: '请输入入职日期'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'date',
              prop: 'ResignationTime',
              label: '离职日期',
              placeholder: '请输入离职日期'
            },
          ]
        },
        {
          title: '特定执业信息（根据实际选填）',
          form: {},
          labelWidth: '130px',
          formItemList: [
            {
              type: 'select',
              xl: 8,
              lg:8,
              md:12,
              prop: 'CivilDutyId',
              label: '公务员职务',
              list: []
            },
            {
              type: 'select',
              xl: 8,
              lg:8,
              md:12,
              prop: 'yishizhicheng',
              label: '医师职称',
              list: []
            },
            {
              type: 'select',
              xl: 8,
              lg:8,
              md:12,
              prop: 'hushijibie',
              label: '护士级别',
              list: []
            },
            {
              type: "cascader",
              label: "执业类别和范围",
              show: false,
              prop: "PracticeTypeId",
              placeholder: "选择执业类别和范围",
              props: {
                lazy: true,
                label: "NAME",
                value: "ID",
                leaf: "leaf",
                lazyLoad(node, resolve) {
                  const { level } = node;
                  let ParentId = "0";
                  if (level !== 0) {
                    ParentId = node.value;
                  }
                  getSortRange({ ParentId }).then(res => {
                    const arr = res.map(v => {
                      v.leaf = level >= 1;
                      return v;
                    });
                    resolve(res);
                  });
                }
              }
            },
            {
              type: 'onlyOrg',
              prop: 'PracticeOrgId',
              label: '执业地点',
              getValue: val => {
                console.log(val, '这是执业地点')
              }
            },
          ]
        },
        {
          title: '教育信息',
          form: {},
          labelWidth: '130px',
          formItemList: [
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '毕业院校',
              prop: 'School',
              type: 'input',
              placeholder: '请输入毕业院校'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '学历',
              prop: 'EducationId',
              type: 'select',
              list: [],
              placeholder: '请输入学历'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '学位',
              prop: 'DegreeId',
              type: 'select',
              list: [],
              placeholder: '请输入学位'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '专业',
              prop: 'Profession',
              type: 'input',
              placeholder: '请输入专业'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '入学时间',
              prop: 'ReadingStartTime',
              type: 'date',
              placeholder: '请输入入学时间'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '毕业时间',
              prop: 'ReadingEndTime',
              type: 'date',
              placeholder: '请输入毕业时间'
            },
          ]
        },
        {
          title: '联系信息',
          name: 'cursomContactInfo'
        },
        {
          title: '附件',
          cursomTitle: true,
          name: 'fileUpload',
          fileSuccess: (a, b, c, d) => {
            if(c.id){
              this.file_0_List.push({
                FilePath: '',
                Name: c.filename,
                HasCode: c.hashcode,
                FileType: 0,
                FileId: c.id,
                Url: c.url
              })
            }
            console.log('这是上传成功后的回调')
            console.log(this.file_0_List)
          },
          fileRemoved: (a) => {
            const fileId = a.id || a[0].id
            const index = this.file_0_List.findIndex((item, i) => {
              return fileId === item.Id || fileId === item.FileId
            })
            console.log(index, '这是iindex_____________')
            if(index !== -1) this.file_0_List.splice(index,1)
          }
        }
      ],
      operate: [
        {
          loadingBtn: false,
          icon: 'el-icon-circle-check',
          type: 'primary',
          name: '提交',
          handleClick: () => {
            this.handleSubmit()
          }
        },
        {
          loadingBtn: false,
          // icon: 'el-icon-check',
          type: 'default',
          name: '取消',
          handleClick: () => {
            this.currentView = 'Container'
          }
        }
      ],
      file_0_List: [],
      file_1_List: [],
      fileConfig: {
        fileStatusText: {
          success: "上传成功",
          error: "上传失败",
          uploading: "上传中",
          paused: "MD5加密",
          waiting: "等待中"
        },
        PathId: "0",
        baseAddress: "http://117.71.55.7:14909",
        currentUser: {
          userId: getToken().userId, //用户id
          userName: getToken().realName //用户名称
        },
        savePath: ""
      },
      src: require('@/assets/默认头像.png'),
      fileStatusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "上传中",
        paused: "MD5加密",
        waiting: "等待中"
      },
      PathId: "0",
      savePath:'',
      // rootId: '',
      baseAddress: 'http://117.71.55.7:14909',
      currentUser: {
        userId: getToken().userId,
        userName: getToken().realName
      },
      EmergencyPostInfoList: [],
      EmergencyCompanyofDeptList: [],
      ContactRules: {
        ContactPhoneInfoList_0: vxRule(true, null, "blur", "至少输入一个号码信息"),
      },
      ContactInfoForm: {
        phoneSelect_0: '登录号码',
        ContactDateInfoList_0: ''
      },
      ContactInfoItem: [
        {
          count: 1,
          prop: 'ContactPhoneInfoList',
          selectLabel: true,
          icon: 'el-icon-phone-outline',
          selectProp: 'phoneSelect',
          selectOptions: [
            {
              lable: '登录号码',
              value: '登录号码'
            },
            {
              lable: '对外显示号码',
              value: '对外显示号码'
            },
            {
              lable: '短信接收号码',
              value: '短信接收号码'
            }
          ]
        },
        {
          count: 1,
          prop: 'ContactEmailInfoList',
          label: '个人邮箱',
          icon: 'el-icon-message',
        },
        {
          count: 1,
          prop: 'ContactImInfoList',
          label: 'QQ',
          icon: 'el-icon-chat-line-round',
        },
        {
          count: 1,
          prop: 'ContactDateInfoList',
          label: '生日',
          disabled: true,
          icon: 'el-icon-user',
        },
        {
          count: 1,
          prop: 'ContactUrlInfoList',
          label: '公司网址',
          icon: 'el-icon-location-information',
        },
        {
          count: 1,
          prop: 'ContactAddressInfoList',
          label: '单位',
          icon: 'el-icon-house',
        },
      ],
    }
  },
  props: {
    updatePersonalInfodialogVisible: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    ...mapState({
      userId: (state) => state.task.userId,
      realName: (state) => state.task.realName,
    }),
  },
  created() {
    // 字典表信息
    this.initDict(
      {prop: 'CivilDutyId', parm: 'gwyzc'}, // 公务员职称
      {prop: 'EducationId', parm: 'xlxx'}, // 学历
      {prop: 'DegreeId', parm: 'xwxx'}, // 学位
      {prop: 'hushijibie', parm: 'hszc'}, // 护士级别
      {prop: 'yishizhicheng', parm: 'yszc'} // 医师职称
    )
      // 职务表
    this.getUserJobList()
    // 个人详情
    this.GetCurrentEmergencyUserInfoById()
  },
  methods: {
    clslogm() {
      this.$emit("closelogm",false)
    },
    cascaderChange() {
      console.log('this.contentConfig[3].form===>',this.contentConfig[3].form)
    },
    selectChange(item) {
      const prop = item.prop
      switch (prop) {
        case 'yishizhicheng':
          if(this.contentConfig[3].form['hushijibie']) { 
            delete this.contentConfig[3].form['hushijibie']
            this.contentConfig[3].form['JobTitleId'] = this.contentConfig[3].form['yishizhicheng']
          }
          break
        case 'hushijibie':
          if(this.contentConfig[3].form['yishizhicheng']) { 
            delete this.contentConfig[3].form['yishizhicheng']
            this.contentConfig[3].form['JobTitleId'] = this.contentConfig[3].form['hushijibie']
          }
          break
      }
    },
    inputChange(item) {
      if(item.prop === 'IdNumber') {
        const BirthDay = this.contentConfig[1].form.IdNumber.slice(6, 14)
        const bArr = BirthDay.split('')
        bArr.splice(4, 0, '-')
        bArr.splice(7, 0, '-')
        this.$set(this.ContactInfoForm, 'ContactDateInfoList_0', )
        this.ContactInfoForm['ContactDateInfoList_0'] = bArr.join('')
        console.log(this.ContactInfoForm)
      }
    },
    async GetCurrentEmergencyUserInfoById() {
      const result = await GetCurrentEmergencyUserInfoById({ userId: this.userId })
      this.userInfoDetails = result
      this.initUserInfoForm()
    },
    initUserInfoForm() {
      this.resetForm()
      if (this.userInfoDetails) {
        const data = this.userInfoDetails
        this.$nextTick(() => {
          data.SysAttachFileList && data.SysAttachFileList.length && data.SysAttachFileList.forEach(file => {
            // fileType 0为附件 1为头像
            if(file.FileType === 0) {
              // 回显附件信息
              this.$refs.uploader.defaultList.push({
                id: file.Id,
                isFolder: false,
                isRoot: false,
                name: file.Name,
                paused: false,
                relativePath: file.Name
              })
              // 赋值附件信息
              this.file_0_List.push({
                FilePath: '',
                Name: file.Name,
                HasCode: file.HasCode,
                FileType: 0,
                FileId: file.FileId,
                Id: file.Id,
                Url: file.Url
              })
            }
            if(file.FileType === 1) {
              const item  = {
                baseAddress:'http://117.71.55.7:14909',
                FileId: file.FileId,
                fileName: file.Name,
                CreateUserId: this.userId,
                CreateUserName: this.realName
              }
              // 回显src
              this.src = this.matchTypeImg(item)
              // 赋值头像信息
              this.file_1_List.push({
                FilePath: '',
                Name: file.Name,
                HasCode: file.HasCode,
                FileType: 1,
                Id: file.Id,
                FileId: file.FileId,
                Url: file.Url
              })
            }
          })
        })
        if(data.Sysuser) {
          this.$set(this.contentConfig[1], 'form', data.Sysuser)
          this.$set(this.contentConfig[2].form, 'Position', data.Sysuser.Position)
          this.$set(this.contentConfig[2].form, 'EntryTime', data.Sysuser.EntryTime)
          this.$set(this.contentConfig[2].form, 'ResignationTime', data.Sysuser.ResignationTime)
          // this.contentConfig[1].form = data.Sysuser
          // this.contentConfig[2].form.Position = data.Sysuser.Position
          // this.contentConfig[2].form.EntryTime = data.Sysuser.EntryTime
          // this.contentConfig[2].form.ResignationTime = data.Sysuser.ResignationTime
          const DutyId = data.Sysuser.DutyId.split(',').map(v => {return v - 0})
          // this.contentConfig[2].form.DutyId = data.Sysuser.DutyId.split(',').map(v => {return v - 0})
          this.$set(this.contentConfig[2].form, 'DutyId', DutyId)
          this.$set(this.contentConfig[3].form, 'CivilDutyId', data.Sysuser.CivilDutyId) // 公务员职务
          // this.contentConfig[3].form.CivilDutyId = data.Sysuser.CivilDutyId 
        }
        if(data.Emergencyaddtioninfo) {
          this.$set(this.contentConfig[1].form, 'Grade', data.Emergencyaddtioninfo.Grade)
          // this.contentConfig[1].form.Grade = data.Emergencyaddtioninfo.Grade
          const DeptList = data.Emergencyaddtioninfo.EmergencyCompanyofDeptList && data.Emergencyaddtioninfo.EmergencyCompanyofDeptList.map(v => {
            return '2_' + v.DeptId
          })
          const PostInfoList = data.Emergencyaddtioninfo.EmergencyPostInfoList && data.Emergencyaddtioninfo.EmergencyPostInfoList.map(v => {
            return v.PostId
          })
          this.$set(this.contentConfig[2].form, 'EmergencyCompanyofDeptList', DeptList)
          this.$set(this.contentConfig[2].form, 'EmergencyPostInfoList', PostInfoList)
          // this.contentConfig[2].form.EmergencyCompanyofDeptList = data.Emergencyaddtioninfo.EmergencyCompanyofDeptList && data.Emergencyaddtioninfo.EmergencyCompanyofDeptList.map(v => {
          //   return '2_' + v.DeptId
          // })
          // this.contentConfig[2].form.EmergencyPostInfoList = data.Emergencyaddtioninfo.EmergencyPostInfoList && data.Emergencyaddtioninfo.EmergencyPostInfoList.map(v => {
          //   return v.PostId
          // })
          // 回显联系信息
          this.ContactInfoItem.forEach(v => {
            const prop = v.prop
            switch (prop) {
              case 'ContactAddressInfoList': // 地址
                data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                  this.ContactInfoForm[prop + '_' + i] = k.Address
                })
                break
              case 'ContactDateInfoList': // 生日
                data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                  this.ContactInfoForm[prop + '_' + i] = k.SpecialDate
                })
                break
              case 'ContactEmailInfoList': // 邮箱
                data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                  this.ContactInfoForm[prop + '_' + i] = k.Email
                })
                break
              case 'ContactPhoneInfoList': // 号码
                data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                  this.ContactInfoForm[prop + '_' + i] = k.Phone
                  this.ContactInfoForm['phoneSelect_' + i] = k.PhoneType
                })
                break
              case 'ContactImInfoList': // qq
                data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                  this.ContactInfoForm[prop + '_' + i] = k.Im
                })
                break
              case 'ContactUrlInfoList': // 网址
                data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                  this.ContactInfoForm[prop + '_' + i] = k.Url
                })
                break
            }
            if(data.Emergencyaddtioninfo[prop].length){
              v.count = data.Emergencyaddtioninfo[prop].length
            }
          })
        }
        this.contentConfig[3].formItemList.forEach(v => {
          if(v.prop === 'PracticeTypeId') v.show = true
        })
        if(data.SysUserPracticeinfo) {
          const PracticeOrgId  = data.SysUserPracticeinfo.PracticeOrgId && data.SysUserPracticeinfo.PracticeOrgId.split(',')
          this.$set(this.contentConfig[3].form, 'PracticeOrgId', PracticeOrgId) // 执业地点
          if(data.SysUserPracticeinfo.ParentPracticeTypeId && data.SysUserPracticeinfo.PracticeTypeId) {
            this.$set(this.contentConfig[3].form, 'PracticeTypeId', [data.SysUserPracticeinfo.ParentPracticeTypeId, data.SysUserPracticeinfo.PracticeTypeId]) // 职业类别和范围
          }
          console.log('this.contentConfig[3].form=================>>>', this.contentConfig[3].form)
          if(data.SysUserPracticeinfo.JobTitleId) {
            const JobTitleId = data.SysUserPracticeinfo.JobTitleId
            if(JobTitleId[0] === 'B') { // B开头为医生, C开头为护士
              // this.contentConfig[3].form.yishizhicheng = JobTitleId
              this.$set(this.contentConfig[3].form, 'yishizhicheng', JobTitleId)
            }else {
              // this.contentConfig[3].form.hushijibie = JobTitleId
              this.$set(this.contentConfig[3].form, 'hushijibie', JobTitleId)
            }
          }
        }
        if(data.SysUserEducationalinfo) this.contentConfig[4].form = data.SysUserEducationalinfo
      }
      
      this.userInfoDetails = null
    },
    initDict() {
      const arg = [].slice.call(arguments)
      for(let i=0; i< arg.length; i++) {
        // 公务员职称
        this.GetDictInfoListByType(arg[i].parm).then(res => {
          // CivilDutyId
          this.setDictSelectOptions(arg[i].prop, res)
          
        })
      }
    },
    initForm() {
      this.EmergencyPostInfoList = []
      this.EmergencyCompanyofDeptList = []
      this.contentConfig.forEach(v => {
        // v.form && v.form = {}
      })
    },
    AddSameContactProp(item) {
      // 登录号码初始化select选择
      if(item.prop === 'ContactPhoneInfoList') {
        this.$set(this.ContactInfoForm, 'phoneSelect_' + item.count, '登录号码')
      }
      this.ContactInfoItem.forEach(v => {
        if(v.prop === item.prop) v.count = v.count + 1
      })
    },
    DeleteSameContactProp(item, i) {
      let form = deepClone(this.ContactInfoForm)
      this.ContactInfoItem.forEach(v => {
        if(v.prop === item.prop) v.count = v.count - 1
      })
      this.ContactInfoForm = {}
      // 删除掉ContactInfoForm对应的值
      if(item.prop === 'ContactPhoneInfoList') {
        delete form['phoneSelect_' + i]
      }
      delete form[item.prop + '_' + i]
      // 重新排列
      let obj = {}
      for (const key in form) {
        const k = key.split('_')[0]
        if(obj.hasOwnProperty(k)) {
          obj[k].push(form[key])
        }else {
          obj[k] = [form[key]]
        }
      }
      for (const key in obj) {
        for(let i=0; i< obj[key].length; i++) {
          // 重新设置ContactInfoForm
          this.$set(this.ContactInfoForm, key + '_' + i, obj[key][i])
        }
      }
    },
    // 获取字典信息（公务员职称， 医师职称， 护士职称， 学历， 学位）
    async GetDictInfoListByType(Stype) {
      let result = await GetDictInfoListByType({Stype})
      return result
    },
    //获取人员职务的数据
    getUserJobList() {
      const Orgid = getToken().organizationId || "";
      getUserJobList({ Opsate: 0, Orgid, pageindex: 1, pagesize: 10000 }).then(
        res => {
          const items = res.Items.map(item => {
            const obj = {
              value: item.ID,
              label: item.NAME
            }
            return obj
          })
          this.contentConfig[2].formItemList.forEach(v => {
            if(v.prop === 'DutyId') v.list = items
          })
        }
      )
    },
    //上传
    fileSuccess(a, b, c, d) {
      const item  = {
         baseAddress:'http://117.71.55.7:14909',
         FileId: c.id,
         fileName: c.filename,
         CreateUserId: this.userId,
         CreateUserName: this.realName
      }
      this.src = this.matchTypeImg(item)
      console.log('这是头像上传成功后的回调=》', c)
      this.file_1_List = {
        FilePath: '',
        Name: c.filename,
        HasCode: c.hashcode,
        FileType: 1,
        FileId: c.id,
        Url: c.url
      }
    },
    setDictSelectOptions(prop, data) {
      this.contentConfig.forEach(v => {
        v.formItemList && v.formItemList.forEach(k => {
          if(k.prop === prop) {
            k.list = data.map(v => {
              const obj = {
                value: v.CODE,
                label: v.NAME
              }
              return obj
            })
            return 
          }
        })
      })
    },
    // 提交
    handleSubmit() {
      // 基础信息
      const Sysuser = deepClone(this.contentConfig[1].form) // 人员级别需要放到辅助信息里面去
      Sysuser.CreateUserId = this.userId
      // 职业信息
      const PostInfo = deepClone(this.contentConfig[2].form) // 职务 职位 入职 离职放到基础信息里面去
      Sysuser.DutyId = PostInfo.DutyId && PostInfo.DutyId.join(',')
      Sysuser.Position = PostInfo.Position
      Sysuser.EntryTime = PostInfo.EntryTime
      Sysuser.ResignationTime = PostInfo.ResignationTime
      // 教育信息
      const SysUserEducationalinfo  = deepClone(this.contentConfig[4].form)
      // 特定执业信息
      const SysUserPracticeinfo = deepClone(this.contentConfig[3].form) // 公务员放到基础信息里面去
      Sysuser.CivilDutyId = SysUserPracticeinfo.CivilDutyId
      SysUserPracticeinfo.PracticeOrgId = SysUserPracticeinfo.PracticeOrgId && SysUserPracticeinfo.PracticeOrgId.join(',') // 执业地点
      SysUserPracticeinfo.PracticeTypeId = SysUserPracticeinfo.PracticeTypeId && SysUserPracticeinfo.PracticeTypeId[SysUserPracticeinfo.PracticeTypeId.length - 1] // 执业类型和范围子节点
      SysUserPracticeinfo.ParentPracticeTypeId = SysUserPracticeinfo.PracticeTypeId && SysUserPracticeinfo.PracticeTypeId[0] // 执业类型和范围 父节点
      SysUserPracticeinfo.JobTitleId = SysUserPracticeinfo.yishizhicheng || SysUserPracticeinfo.hushijibie // 职称
      // 文件
      const SysAttachFileList = [].concat(this.file_0_List, this.file_1_List)
      // delete Sysuser.Grade
      
      const ContactPhoneInfoList = [] // 电话
      const ContactEmailInfoList = [] // 邮箱
      const ContactImInfoList = [] // qq
      const ContactDateInfoList = [] // 生日
      const ContactUrlInfoList = [] // 网址
      const ContactAddressInfoList = [] // 地址
      for (const key in this.ContactInfoForm) {
        if(key.indexOf('ContactPhoneInfoList') !== -1) {
          const index = key.split('_')[1]
          ContactPhoneInfoList.push({
            PhoneType: this.ContactInfoForm['phoneSelect_' + index],
            Phone: this.ContactInfoForm[key]
          })
        }
        if(key.indexOf('ContactEmailInfoList') !== -1) ContactEmailInfoList.push({Email: this.ContactInfoForm[key], EmailType: '个人邮箱'})
        if(key.indexOf('ContactImInfoList') !== -1) ContactImInfoList.push({ImType: 'QQ', Im: this.ContactInfoForm[key]})
        if(key.indexOf('ContactDateInfoList') !== -1) ContactDateInfoList.push({DateType: '生日', SpecialDate: this.ContactInfoForm[key]})
        if(key.indexOf('ContactUrlInfoList') !== -1) ContactUrlInfoList.push({UrlType: '公司网址', Url: this.ContactInfoForm[key]})
        if(key.indexOf('ContactAddressInfoList') !== -1) ContactAddressInfoList.push({AddressType: '单位', Address: this.ContactInfoForm[key]})
      }
      // 辅助信息
      const Emergencyaddtioninfo = {
        Grade: Sysuser.Grade,
        EmergencyPostInfoList: this.EmergencyPostInfoList, // 岗位
        EmergencyCompanyofDeptList: this.EmergencyCompanyofDeptList, // 机构组织
        ContactPhoneInfoList, // 电话
        ContactEmailInfoList, // 邮箱
        ContactImInfoList, // qq
        ContactDateInfoList, // 生日
        ContactUrlInfoList, // 网址
        ContactAddressInfoList // 地址
      }
      delete Sysuser.Grade
      delete SysUserPracticeinfo.yishizhicheng
      delete SysUserPracticeinfo.hushijibie
      // 文件
      const EmergencyUserInfo = {
        Sysuser,
        SysUserEducationalinfo,
        SysUserPracticeinfo,
        SysAttachFileList,
        Emergencyaddtioninfo
      }
      let flag = true
      this.$refs.AddOrEditFormView.$refs.form.forEach(v => {
        v.validate(val => {
          if(!val) {
            flag = false
            return
          }
        })
      })
      this.$refs.contactForm.validate(v => {
        if(!v) flag = false
      })
      if(flag) {
        upDateUserInfo({ ...EmergencyUserInfo }).then(res => {
          this.$notify({
            message: '个人信息【修改】成功',
            duration: 2000,
            type: 'success'
          })
          this.clslogm()
        })
      }
    },
    matchTypeImg(item) {
      // 后缀获取
      var suffix = "";
      // 获取类型结果
      var result = "";
      try {
        var flieArr = item.fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return require("@/assets/quality_pic.png");
      }
      suffix = suffix.toLowerCase();
      // 图片格式
      var imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        return `${item.baseAddress}/api/File/Preview?FileId=${item.FileId}&FileName=${item.fileName}&CreateUserId=${item.CreateUserId}&CreateUserName=${item.CreateUserName}`
      }
    },
    resetForm() {
      this.contentConfig.forEach((v, i) => {
        if(v.form) v.form = {} // 置空form表单
        if(i === 1) v.form = { Grade: 3, SysId : '' } // 默认等级为三级, SysId新增时为空
        this.ContactInfoForm = { phoneSelect_0: '登录号码' } // 联系信息初始化
      })
      this.ContactInfoItem.forEach(v => { v.count = 1 })
      this.file_1_List = []
      this.file_0_List = []
    },
  }
}
</script>
<style lang="scss" scoped>
  .contact-info-item-btns {
    display: inline-block;
    width: 100px;
  }
  .contact-info-item-icon {
    font-size: 22px;
  }
  .contact-info-item {
    .contact-info-item-label-wrap {
      display: flex;
      align-items: center;
    }
    .contact-info-item-select-wrap {
      /deep/.el-input__inner {
        border: none;
      }
    }
    /deep/ .el-form-item__content {
      display: flex;
    }
    /deep/.el-button {
      margin-left: 10px;
    }
    .contact-info-item-btns {
      display: inline-block;
      width: 100px;
    }
    .contact-info-item-icon {
      font-size: 22px;
    }
  }
  /deep/.contact-info-item-validate {
    .el-form-item__label {
      position: relative;
    }
  }
  /deep/.contact-info-item-validate.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
  }
  .contact-el-row {
    width: 100%;
  }
  /deep/.user-picture-wrap{
    width: 210px;
    img{
      width: 100%;
    }
  }
  .registerCapital-cursom-item{
    display: flex;
  }
    .basic-qualification-info-wrap{
      margin-bottom: 50px;
    }
    .organ-picture-wrap {
      width: 180px;
      height: 180px;
      overflow: hidden;
      border-radius: 50%;
      overflow: hidden;
      // border: 1px solid #1890ff;
      img {
        width: 100%;
      }
    }
    .qualify-picture-wrap{
      img {
        width: 100%;
      }
    }
    /deep/ .item-wrap-pic{
        .uploader {
          margin-bottom: 30px;
          margin-top: 10px;
          text-align: center;
        }
      }
    /deep/.uploader-btn{
      border: none;
      padding: 0;
    }
    .basic-qualification-info-wrap{
      padding:0 35px;
      .el-row {
        display: flex;
        align-items: center;
      }
    }
    .area-cursom-item {
      width: 70%;
    }
    .cursom-item, .area-cursom-item{
      .padding-20 {
        padding: 0;
      }
    }
    .cursom-cascader {
      width: 100%;
      margin-bottom: 10px;
    }
    th {
      border: 1px solid #f3f3f3;
      background-color: #f8f9f9;
    }
    /deep/ .el-form-item.el-form-item--small{
      align-items: flex-start;
    }
    .item-wrap-title /deep/.uploader-btn {
      color: #1cb8a7;
      background-color: #fff;
      border: 1px solid #1cb8a7;
      font-size: 14px;
      border-radius: 4px;
      padding: 4px;
      margin-left: 10px;
      width: 100px;
      text-align: center;
    }
    .add-or-edit-form-wrap{
      position: relative;
      z-index: 1;
      .form-button-wrap{
        // position: fixed;
        // top: 80px;
        // left: 260px;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 1000;
        height: 62px;
        line-height: 62px;
        background-color: #fff;
        width: calc(100vw - 280px);
        min-width: 1020px;
        padding-left: 10px;
        box-shadow: 0 0 6px 3px #e9e9e9;
        border-radius: 2px;
      }
    }
</style>
<style>
  .update-info-wrap{
    text-align: left;
  }
  .update-info-wrap .el-dialog{
      height: calc(100vh - 10.2vh);
      margin-top: 5vh !important;
      overflow-y: scroll;
    }
  .margin-l-10.el-button {
    margin-left: 10px !important;
  }
  .margin-l-20.el-button {
    margin-left: 20px !important;
  }
  .el-cascader-node__label{
    text-align: left;
  }
</style>